/* eslint-disable no-unused-vars */
import PersonHome from '../views/person/PersonHome.vue'
import PersonDataPribadi from '../views/person/PersonDataPribadi.vue'
import PersonPengalaman from '../views/person/PersonPengalaman.vue'
import PersonSertifikat from '../views/person/PersonSertifikat.vue'


const person = [  
  {
    path: '/person/home',
    component: PersonHome,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/person/data',
    component: PersonDataPribadi,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/person/pengalaman',
    component: PersonPengalaman,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/person/sertifikat',
    component: PersonSertifikat,
    meta: { auth: true, vendor: true }    
  }
]

export default person
